export default {
    currentBatch: null,
    history: [],
    isPolling: false,
    isDispatching: false,
    isCancelling: false,
}
